var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5749 10.85H8.8249L9.7249 7.25H6.5749V5.45C6.5749 4.523 6.5749 3.65 8.3749 3.65H9.7249V0.626C9.4315 0.5873 8.3236 0.5 7.1536 0.5C4.7101 0.5 2.9749 1.9913 2.9749 4.73V7.25H0.274902V10.85H2.9749V18.5H6.5749V10.85Z",
    fill: "#759CEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f02f887fbddb2ed06ecc548409dd81b1.svg";
export { ForwardRef as ReactComponent };